//对于axios进行二次封装
import axios from "axios";
import { Message} from 'element-ui';
//底下的代码也是创建axios实例
const requests = axios.create({
	//基础路径
	baseURL: "/todo/api",
	//请求不能超过5S
	timeout: 5000,
});

//请求拦截器（可以在请求发出去之前，做一些事情）
requests.interceptors.request.use((config) => {
	return config;
});

//响应拦截器（在数据返回之后，做一些事情）
requests.interceptors.response.use(
	(res) => {
		//相应成功
		if (!res.data.success){
			Message.error(res.data.errMsg);
		}
		return res.data;
	},
	(err) => {
		//响应失败
		//alert("服务器响应数据失败");
		console.log("err:", err)
		Message.error(err.data.errMsg);
	}
);
export default requests;